import { useAppSelector, useAppDispatch } from "redux/hooks";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import {
  setShowLoadUserError,
  setShowEditUserError,
  setShowInviteUserError,
  setShowDeleteUserError,
  setShowSaveComplianceSettingError,
  setShowNoCompliantParticipantView,
  setShowNoNonCompliantParticipantView,
  setShowNoParticipantView,
} from "test_tools/TestConfigSlice";
import { Button } from "@verily-src/react-design-system";
import { telemetry } from "core/TelemetryController";

function TestTools() {
  const dispatch = useAppDispatch();
  const testConfig = useAppSelector((state) => state.testConfig);

  return (
    <div className="main-content-page">
      <Typography variant="display4">Testing</Typography>
      <FormGroup
        sx={{
          marginTop: "16px",
          padding: "16px",
          border: "1px solid #CED4D8",
          borderRadius: "4px",
          width: "500px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showLoadUserError}
              onChange={(event) => {
                dispatch(setShowLoadUserError(event.target.checked));
              }}
            />
          }
          label="Show load user error"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showInviteUserError}
              onChange={(event) => {
                dispatch(setShowInviteUserError(event.target.checked));
              }}
            />
          }
          label="Show invite user error"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showEditUserError}
              onChange={(event) => {
                dispatch(setShowEditUserError(event.target.checked));
              }}
            />
          }
          label="Show edit user error"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showDeleteUserError}
              onChange={(event) => {
                dispatch(setShowDeleteUserError(event.target.checked));
              }}
            />
          }
          label="Show delete user error"
        />
      </FormGroup>

      <FormGroup
        sx={{
          marginTop: "16px",
          padding: "16px",
          border: "1px solid #CED4D8",
          borderRadius: "4px",
          width: "500px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showSaveComplianceSettingError}
              onChange={(event) => {
                dispatch(
                  setShowSaveComplianceSettingError(event.target.checked)
                );
              }}
            />
          }
          label="Show publish compliance setting error"
        />
      </FormGroup>

      <FormGroup
        sx={{
          marginTop: "16px",
          padding: "16px",
          border: "1px solid #CED4D8",
          borderRadius: "4px",
          width: "500px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showNoParticipantView}
              onChange={(event) => {
                dispatch(setShowNoParticipantView(event.target.checked));
              }}
            />
          }
          label="Show no participant view"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showNoCompliantParticipantView}
              onChange={(event) => {
                dispatch(
                  setShowNoCompliantParticipantView(event.target.checked)
                );
              }}
            />
          }
          label="Show no compliant participant view"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={testConfig.showNoNonCompliantParticipantView}
              onChange={(event) => {
                dispatch(
                  setShowNoNonCompliantParticipantView(event.target.checked)
                );
              }}
            />
          }
          label="Show no non-compliant participant view"
        />
      </FormGroup>

      <FormGroup
        sx={{
          marginTop: "16px",
          padding: "16px",
          border: "1px solid #CED4D8",
          borderRadius: "4px",
          width: "500px",
        }}
      >
        <Button
          variant="outlined"
          label="Throw error"
          onClick={() => {
            throw new Error("Throw an error to test DataDog integration");
          }}
          sx={{ width: "200px" }}
        />
        <Button
          variant="outlined"
          label="Log error"
          onClick={() => {
            telemetry.logError(
              new Error("Log an error to test DataDog integration")
            );
          }}
          sx={{ marginTop: "16px", width: "200px" }}
        />
      </FormGroup>
    </div>
  );
}

export default TestTools;
